import EdViewer from './src/EdViewer.vue';

/* istanbul ignore next */
EdViewer.install = function (Vue) {
    Vue.component(EdViewer.name, EdViewer)
}

export default EdViewer;
